<template>
    <div class="main">
        <c-panel title="CADASTRO FACIAL E CONSENTIMENTO" titleIcon="fas fa-id-badge">
            <el-alert type="warning" :closable="false" class="u-mb-15"
                title="Dado biométrico é dado pessoal SENSÍVEL (LGPD art. 5º, II)."
                description="A face de um aluno só é sincronizada com consentimento registrado e documento anexado. Revogar mantém a trilha e remove a face dos equipamentos."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Turma" class="u-mb-0">
                            <el-select v-model="filtro.turma_id" clearable filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Aluno" class="u-mb-0">
                            <el-input v-model="filtro.aluno" placeholder="Pesquisar..." @keyup.native.enter="carregar"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-row v-if="dados" :gutter="10" class="u-mb-20">
                <el-col :xs="12" :sm="4"><div class="kpi"><span class="n">{{ dados.resumo.total }}</span><span class="r">Alunos</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-ok"><span class="n">{{ dados.resumo.com_consentimento }}</span><span class="r">Com consentimento</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-ok"><span class="n">{{ dados.resumo.sincronizados }}</span><span class="r">Sincronizados</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi"><span class="n">{{ dados.resumo.pendentes }}</span><span class="r">Pendentes</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-erro"><span class="n">{{ dados.resumo.com_erro }}</span><span class="r">Com erro</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-alerta"><span class="n">{{ dados.resumo.sem_foto }}</span><span class="r">Sem foto</span></div></el-col>
            </el-row>

            <div v-if="dados" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Aluno</th>
                            <th style="width: 110px;" class="u-text-center">Foto</th>
                            <th style="width: 190px;" class="u-text-center">Consentimento</th>
                            <th style="width: 150px;" class="u-text-center">Sincronização</th>
                            <th style="width: 170px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="a in dados.itens" :key="a.aluno_id">
                            <td>
                                {{ a.aluno_nome }}
                                <div v-if="a.ultimo_erro"><small class="u-text-danger">{{ a.ultimo_erro }}</small></div>
                            </td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="a.tem_foto ? 'success' : 'danger'">{{ a.tem_foto ? 'sim' : 'não' }}</el-tag>
                            </td>
                            <td class="u-text-center">
                                <el-tag v-if="a.revogado_em" size="mini" type="danger">Revogado</el-tag>
                                <el-tag v-else-if="a.consentimento_lgpd" size="mini" type="success">
                                    {{ dataBr(a.data_consentimento) }}
                                </el-tag>
                                <el-tag v-else size="mini" type="info">Sem consentimento</el-tag>
                            </td>
                            <td class="u-text-center">
                                <el-tag v-if="a.situacao_sync" size="mini" :type="corSync(a.situacao_sync)">{{ a.situacao_sync }}</el-tag>
                                <span v-else>—</span>
                            </td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever && !consentimentoVigente(a)" size="mini" type="primary" plain
                                    :disabled="!a.tem_foto" @click="abrirConsentimento(a)">CONSENTIR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever && consentimentoVigente(a)" size="mini" type="danger" plain
                                    @click="abrirRevogacao(a)">REVOGAR</el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="dados.itens.length === 0"><td colspan="5" class="u-text-center">Nenhum aluno para os filtros informados.</td></tr>
                    </tbody>
                </table>
            </div>

            <el-alert v-else type="info" :closable="false" title="Selecione a escola e o período letivo."></el-alert>

            <!-- ==================== CONSENTIMENTO ==================== -->
            <el-dialog title="Registrar consentimento LGPD" :visible.sync="dialogoC" width="560px">
                <el-alert v-if="atual" type="info" :closable="false" class="u-mb-15" :title="atual.aluno_nome"
                    description="O consentimento deve ter sido assinado pelo responsável. Anexe ou informe onde o documento está arquivado."></el-alert>
                <el-form label-position="top">
                    <el-form-item label="Data do consentimento">
                        <el-date-picker v-model="formC.data_consentimento" type="date" format="dd/MM/yyyy"
                            value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="Documento de consentimento">
                        <el-input v-model="formC.documento_consentimento"
                            placeholder="Ex.: consentimentos/2026/termo-joao-silva.pdf"></el-input>
                        <small>Caminho, protocolo ou referência do termo assinado.</small>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoC = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :disabled="!formC.data_consentimento || !formC.documento_consentimento"
                        @click="salvarConsentimento">REGISTRAR</el-button>
                </span>
            </el-dialog>

            <!-- ==================== REVOGAÇÃO ==================== -->
            <el-dialog title="Revogar consentimento" :visible.sync="dialogoR" width="560px">
                <el-alert type="warning" :closable="false" class="u-mb-15"
                    title="A face será removida dos equipamentos e o template será apagado."
                    description="O registro do consentimento e da revogação permanece, com data, autor e motivo."></el-alert>
                <el-form label-position="top">
                    <el-form-item label="Motivo da revogação">
                        <el-input v-model="motivoR" type="textarea" :rows="3"
                            placeholder="Ex.: solicitação da responsável em 12/04/2026."></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoR = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="danger" :disabled="!motivoR" @click="salvarRevogacao">REVOGAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO J — item 127: cadastro facial e consentimento LGPD. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        instituicaoId: null, periodoId: null, instituicoes: [], turmas: [],
        filtro: { turma_id: '', aluno: '' }, dados: null,
        dialogoC: false, dialogoR: false, atual: null, motivoR: '',
        formC: { data_consentimento: '', documento_consentimento: '' }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregarTurmas())
    },
    methods: {
        consentimentoVigente (a) { return !!a.consentimento_lgpd && !a.revogado_em },
        corSync (s) {
            return { sincronizado: 'success', pendente: 'info', erro: 'danger', removido: 'warning' }[s] || 'info'
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        carregarTurmas () {
            this.turmas = []; this.filtro.turma_id = ''; this.dados = null
            if (!this.instituicaoId || !this.periodoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() }).catch(() => {})

            this.carregar()
        },
        carregar () {
            this.dados = null
            if (!this.instituicaoId) return

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/face-aluno/getPorInstituicao/${this.instituicaoId}`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.dados = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirConsentimento (a) {
            this.atual = a
            this.formC = { data_consentimento: new Date().toISOString().substring(0, 10), documento_consentimento: '' }
            this.dialogoC = true
        },
        salvarConsentimento () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/face-aluno/consentimento/${this.atual.aluno_id}`,
                this.formC, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogoC = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirRevogacao (a) { this.atual = a; this.motivoR = ''; this.dialogoR = true },
        salvarRevogacao () {
            // A revogação APAGA o template biométrico e é irreversível: o responsável
            // terá que consentir de novo e a face precisará ser recadastrada.
            this.$confirm('A revogação apaga definitivamente o template biométrico do aluno. Para voltar a usar o reconhecimento facial será necessário novo consentimento e novo cadastro. Confirma?',
                'Revogar consentimento', { confirmButtonText: 'Revogar', cancelButtonText: 'Cancelar', type: 'warning' })
                .then(() => this.executarRevogacao()).catch(() => {})
        },
        executarRevogacao () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/face-aluno/revogar/${this.atual.aluno_id}`,
                { motivo: this.motivoR }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogoR = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 20px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-ok { border-left: 4px solid #67c23a; }
.kpi-erro { border-left: 4px solid #f56c6c; }
.kpi-alerta { border-left: 4px solid #e6a23c; }
.u-text-danger { color: #f56c6c; }
</style>
